import { defineComponent as _defineComponent } from 'vue'
import {CustomerOrderSummary, CustomerOrderTeamLeader} from "@/service/CustomerOrderService";
  import {PropType, reactive} from "vue";
  import {MessageTypes} from "@/components/message-types";
  import {t} from "@/mixin/mixins";
  import eventBus from "@/eventbus";
  import router from "@/router";
  import {formatDate} from "@/filter";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerOrdersPast',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array as PropType<Array<CustomerOrderSummary>>,
      required: true,
      default: () => new Array<CustomerOrderSummary>()
    }
  },
  emits: ["avgPosChanged"],
  setup(__props, { emit }) {

const props = __props

  class AvgRowModel {
    numberOfPositions: number | null;
  }

  

  const initialState = {
    avgItem: {} as AvgRowModel
  };
  const state = reactive({...initialState});

  const headers = [
    {
      text: t("date.text"),
      value: "validFrom",
      align: "left"
    },
    {
      text: t("orderName"),
      value: "name",
      align: "left"
    },
    {
      text: t("date.start"),
      value: "workStart",
      align: "left"
    },
    {
      text: t("date.end"),
      value: "workEnd",
      align: "left"
    },
    {
      text: t("employee.teamlead"),
      value: "teamLeader",
      align: "left"
    },
    {
      text: t("employee.employeeCount"),
      value: "employeeCount",
      align: "end"
    },
    {
      text: t("order.operators.numberOfPositions"),
      value: "positions",
      align: "end"
    },
    {
      text: t("order.operators.positionsPerHour"),
      value: "positionsPerHour",
      align: "end"
    },
    {
      text: t("time.hours"),
      value: "workedMinutes",
      align: "end"
    },
    {
      value: "actions",
      width: 104,
      sortable: false
    }
  ];

  // The order views resolve an order's uuid to its numeric id
  const openOrderInNew = (item: CustomerOrderSummary) => {
    let routeData = router.resolve({
      path: `/orders/${item.id}/worklogs`,
      query: {view: "table", date: item.validFrom.slice(0, 7)}
    });
    window.open(routeData.href, "_blank");
  };

  const openNotes = (item: CustomerOrderSummary) => {
    eventBus.$emit(MessageTypes.INFO, t("order.orderInfo.notes.title"), item.notes);
  };

  const date = (item: CustomerOrderSummary) => {
    if (!item.validTo || item.validFrom === item.validTo) {
      return formatDate(item.validFrom, "DD.MM.YYYY (dd)");
    } else {
      return formatDate(item.validFrom, "DD") + " - " + formatDate(item.validTo, "DD.MM.YYYY (dd)");
    }
  };

  const fullName = (teamLeader?: CustomerOrderTeamLeader) => {
    return teamLeader ? `${teamLeader.firstName} ${teamLeader.lastName}` : "–";
  };

  const positionsPerHour = (item: CustomerOrderSummary) => {
    if (item.positions && item.workedMinutes > 0) {
      const positionsPerHour = item.positions / (item.workedMinutes / 60);
      return Math.round(positionsPerHour);
    } else {
      return "–";
    }
  };

  

  const currentItems = (currentItems: CustomerOrderSummary[]) => {
    calcAvgPos(currentItems);
  };

  // The average counts only the orders with positions; without any, it is 0
  const calcAvgPos = (currentItems: CustomerOrderSummary[]) => {
    if (currentItems?.length > 0) {
      const relevantItems = currentItems.filter(item => item.positions && item.positions > 0);
      const sum = relevantItems.reduce((pos, currentItem) =>
        pos + (currentItem.positions ?? 0), 0);
      const avgPos = relevantItems.length > 0 ? Math.round(sum / relevantItems.length) : 0;
      state.avgItem.numberOfPositions = avgPos || null;
      emit("avgPosChanged", avgPos);
    }
  };

return { __sfc: true,AvgRowModel, props, initialState, state, headers, openOrderInNew, openNotes, date, fullName, positionsPerHour, emit, currentItems, calcAvgPos, t }
}

})